import { Skeleton, Box } from '@mui/material';

const WIDTH_WITHOUT_PADDING = { xs: '100%' };
const WIDTH_WITH_PADDING = { xs: '100%', };

export default function TourDrawerSkeleton() {
    const style = {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            mb: '10px',
            textAlign: 'center'
        },
        containerText: { fontSize: '1.3rem', width: WIDTH_WITH_PADDING }
    }

    return (
        <Box sx={{ width: WIDTH_WITHOUT_PADDING }}>
            <Skeleton sx={{ width: WIDTH_WITHOUT_PADDING, height: { xs: 210, lg: 220, xl: 280 } }} variant="rectangular" />
            <Box sx={{ maxWidth: WIDTH_WITHOUT_PADDING }} p={1} ml={3} mr={2} mt={2}>
                <Box pb={1}>
                    {/* <Box pr={1} width={'100%'}> */}
                    <Skeleton variant="text" sx={{ fontSize: '2.3rem', transform: 'unset' }} />
                    <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} />
                    {/* </Box> */}
                    {/* <Box>
                        <Skeleton sx={{ mb: 1, width: { xs: 60, sm: 80 } }} variant="rectangular" height={100} />
                    </Box> */}
                </Box>
                <Box p={1}>
                    <Box sx={style.container}>
                        <Skeleton sx={{ width: 20, mr: 2 }} variant="rectangular" height={20} />
                        <Skeleton variant="text" sx={style.containerText} />
                    </Box>
                    <Box sx={style.container}>
                        <Skeleton sx={{ width: 20, mr: 2 }} variant="rectangular" height={20} />
                        <Skeleton variant="text" sx={style.containerText} />
                    </Box>
                    <Box sx={style.container}>
                        <Skeleton sx={{ width: 20, mr: 2 }} variant="rectangular" height={20} />
                        <Skeleton variant="text" sx={style.containerText} />
                    </Box>
                    {/* <Box sx={style.container}>
                        <Skeleton sx={{ width: 20, mr: 2 }} variant="rectangular" height={20} />
                        <Skeleton variant="text" sx={style.containerText} />
                    </Box> */}
                </Box>
                <Box display={"flex"}>
                    <Skeleton sx={{ my: 1, width: '100%' }} variant="rounded" height={40} />
                </Box>
            </Box>
        </Box>
    )
}          